import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { EmptyListState } from '../../../../components/ui-kit/EmptyListState'
import { UsersList } from '../../../../components/Users/UsersList'
import { usersListQueryArgsFromSearchParams } from '../../../../components/Users/usersListQueryArgs'
import { useLazyGetMyFollowingPageQuery } from '../../../../api/users'
import { useUsersWindowedPage } from '../../../../hooks/useUsersWindowedPage'

export const UsersSubscriptions = () => {
  const [searchParams] = useSearchParams()
  const usersQueryArgs = useMemo(() => usersListQueryArgsFromSearchParams(searchParams), [searchParams])
  const resetKey = useMemo(() => `following:${JSON.stringify(usersQueryArgs)}`, [usersQueryArgs])

  const [loadPage] = useLazyGetMyFollowingPageQuery()
  const {
    items,
    hasMore,
    isInitialLoading,
    isFetchingMore,
    isError,
    loadMore,
  } = useUsersWindowedPage(resetKey, loadPage, usersQueryArgs)

  const hasActiveFilters = Object.keys(usersQueryArgs).length > 0

  if (isInitialLoading && items.length === 0) {
    return <EmptyListState message="Загрузка подписок..." />
  }

  if (isError) {
    return <EmptyListState message="Не удалось загрузить подписки" />
  }

  if (items.length === 0) {
    return (
      <EmptyListState
        message={
          hasActiveFilters
            ? 'Нет подписок с таким фильтром'
            : 'Здесь будут люди, на которых вы подписаны'
        }
      />
    )
  }

  return (
    <UsersList
      users={items}
      hasMore={hasMore}
      isLoadingMore={isFetchingMore && hasMore}
      onLoadMore={() => void loadMore()}
    />
  )
}
